<template>
  <b-modal id="modal-cadastro-video" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cadastrar vídeo do Youtube</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastro-video')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-key"></i> Dados do vídeo</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomeVideo"  label="Nome do vídeo *" :text="{ required: 'Obrigatório informar o nome do vídeo' }" :field="$v.video.video">
            <input type="text" class="form-control" id="nomeVideo" placeholder="" v-model="video.video" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <form-group id="linkVideo"  label="Link do vídeo *" :text="{ required: 'O link do vídeo não é válido' }" :field="$v.video.link">
                <input type="text" class="form-control" id="linkVideo" placeholder="" v-model="link_youtube" value="" />
              </form-group>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="nomeCoordenador"  label="Coordernador *" :text="{ required: 'Obrigatório informar o nome do coordenador' }" :field="$v.video.coordenador">
            <select class="form-control" id="nomeCoordenador" v-model="video.coordenador">
              <option value="">Selecione</option>
              <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
            </select>
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <form-group id="nomeProfessor" label="Professor *" :text="{ required: 'Obrigatório informar o nome do professor' }" :field="$v.video.professor">
                <select class="form-control" id="nomeProfessor" v-model="video.professor">
                  <option value="">Selecione</option>
                  <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
                </select>
              </form-group>
          </div>
        </div>
      </div>
      <h6><i class="fas fa-film"></i> Duração do vídeo</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Horas</label>
                <input type="number" min="0" class="form-control" id="horasVideo" placeholder="" v-model="horas" value="" />
              </div>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Minutos</label>
                <input type="number" min="0" class="form-control" id="minutosVideo" placeholder="" v-model="minutos" value="" />
              </div>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Segundos</label>
                <input type="number" min="0" class="form-control" id="segundosVideo" placeholder="" v-model="segundos" value="" />
              </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarVideo">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastro-video')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import VideoAPI from '@/api/video-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalCadastroVideo',
  components: {
    FormGroup
  },
  inheritAttrs: false,
  props: {
    professores: Array
  },
  data () {
    return {
      video: {
        video: '',
        coordenador: '',
        professor: '',
        link: null,
        vimeo: 0,
        duration: null
      },
      link_youtube: '',
      horas: 0,
      minutos: 0,
      segundos: 0
    }
  },

  watch: {
    link_youtube () {
      var regex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      var match = this.link_youtube.match(regex)
      if (match && match[2].length === 11) {
        this.video.link = 'https://www.youtube.com/embed/' + match[2]
      } else {
        this.video.link = null
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
    })
  },

  validations: {
    video: {
      video: { required },
      coordenador: { required },
      professor: { required },
      duration: { required },
      link: { required }
    },
    link_youtube: { required }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastro-video')
    },

    cadastrarVideo: function () {
      this.video.duration = parseInt(this.horas) * 3600 + parseInt(this.minutos) * 60 + parseInt(this.segundos)
      this.$v.video.$touch()
      if (!this.$v.video.$invalid) {
        const loader = this.$loading.show()
        VideoAPI.salvarYoutube(this.video).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Vídeo criado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastro-video')
            this.video = {
              video: '',
              coordenador: '',
              professor: '',
              link: null,
              vimeo: 0,
              duration: null
            }
            this.link_youtube = ''
            this.horas = 0
            this.minutos = 0
            this.segundos = 0
            this.$emit('videoSalvo')
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
